import React, { useRef, useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { c as classnames } from '../../../index-2586sEvh.js';
import { useTranslation } from 'next-i18next';
import '../../../context/index.js';
import '../../../utils/logToSlack.js';
import '../../../animations--PMkOS0j.js';
import 'cookies-next';
import '../../../currency-_kacFJHO.js';
import '../../../language-BHHwgtQp.js';
import '../../../payment-YC9H491Y.js';
import useAutoFocus from '../../../hooks/useAutoFocus.js';
import '../../../index-sNwiaBfD.js';
import 'next/router';
import useGetPortalRoot from '../../../hooks/useGetPortalRoot.js';
import 'notistack';
import 'lodash/get';
import '../../../product-_pRduMz7.js';
import '../../../helpers-kA_hdoOI.js';
import 'lodash';
import FocusTrap from '../../FocusTrap/index.js';
import IconButton from '../../IconButton/index.js';
import ModalHeader from '../ModalHeader/index.js';
import '../../../_commonjsHelpers-jjO7Zipk.js';
import '../../../index-RkBJ48Nr.js';
import 'i18next';
import 'react-i18next';
import '../../../index-_7uIHHAF.js';
import '../../../utils/portalRoot.js';
import '../../../utils/product.js';
import '../../../utils/logger.js';
import '../../../paths-ZKN3m62_.js';
import '../../../cookies-l-jEMp6P.js';

const PORTAL_ID = 'modal-root';
const ModalContent = ({ children, footer, open, maxWidth = 'sm', padding = 'md', title, subtitle, ariaLabel = '', capitalizeTitle, className = '', removeBorder = false, center = false, autoFocusTag = 'button:not([data-focus-control])', headingId, onClose, enableScrollingBackground = false, extraContent, }) => {
    const { t } = useTranslation('');
    const bodyRef = useRef(document.querySelector('body'));
    const [portalRoot, isVisible] = useGetPortalRoot(open, headingId !== null && headingId !== void 0 ? headingId : PORTAL_ID);
    // Allow Escape key to dismiss the drawer
    // Using "useCallback" to avoid an issue with different function reference on component rerender
    // which can cause to incorrect removing of event listeners
    const onKeyUp = useCallback((e) => {
        if (e.key !== 'Escape')
            return;
        onClose();
    }, []);
    const onOpenEvents = () => {
        if (!enableScrollingBackground) {
            bodyRef.current.style.overflow = 'hidden';
            window.addEventListener('keyup', onKeyUp);
        }
    };
    const onCloseEvents = () => {
        bodyRef.current.style.overflow = '';
        window.removeEventListener('keyup', onKeyUp);
    };
    const maxWidthCSSValue = (passedWidth) => {
        let width;
        switch (passedWidth) {
            case 'xs':
                width = 444;
                break;
            case 'sm':
                width = 700;
                break;
            case 'md':
                width = 900;
                break;
            case 'lg':
                width = 1200;
                break;
            case 'xl':
                width = 1536;
                break;
            case 'fit-content':
                return 'fit-content';
            case false:
                break;
            default:
                width = passedWidth;
                break;
        }
        if (width) {
            return `${width}px`;
        }
        return '100%';
    };
    useEffect(() => {
        if (open) {
            onOpenEvents();
        }
        else {
            onCloseEvents();
        }
    }, [open]);
    useEffect(() => () => {
        // Always remove event listeners on unMount
        onCloseEvents();
    }, []);
    const autoFocus = useAutoFocus({ tag: autoFocusTag });
    if (!portalRoot)
        return null;
    return (React.createElement(React.Fragment, null, createPortal(React.createElement("div", { "aria-hidden": open ? 'false' : 'true', className: classnames('base-modal', `modal-padding-${padding}`, {
            in: isVisible,
        }) },
        React.createElement("div", { className: "backdrop", role: "presentation", onClick: onClose }),
        React.createElement("div", { className: "modal-container", role: "dialog", ...(title && !ariaLabel ? { 'aria-labelledby': 'modal-heading' } : {}), ...(ariaLabel ? { 'aria-label': ariaLabel } : {}) },
            React.createElement("div", { ref: autoFocus, className: classnames('base-modal-root', removeBorder && 'no-border', center && 'modal-centered', className), style: { maxWidth: `${maxWidthCSSValue(maxWidth)}` } },
                React.createElement(FocusTrap, null,
                    React.createElement(IconButton, { "aria-label": t('$common.$labels.closeModal'), title: t('$common.$labels.closeModal'), btnClassName: "modal-btn-close", iconClassName: "icon-close", onClick: onClose }),
                    React.createElement(ModalHeader, { headingId: headingId, title: title, capitalize: capitalizeTitle }),
                    subtitle && React.createElement("div", { className: "modal-subtitle" }, subtitle),
                    children && (React.createElement("div", { className: `modal-body ${title ? '' : 'no-heading'}` }, children)),
                    footer && React.createElement("div", { className: "modal-footer" }, footer)),
                extraContent))), portalRoot)));
};

export { ModalContent as default };
//# sourceMappingURL=index.js.map
